export const CareSelector = {
	init(root = document) {
		const selector = () => {
			root.querySelectorAll(".soins-selector").forEach((select) => {
				if (select.tomselect) return;
				if (typeof window.TomSelect !== "function") return; // TomSelect can be loaded deferred

				new window.TomSelect(select, {
					create: false,
					allowEmptyOption: true,
					maxOptions: 200,
					dropdownParent: "body",
					closeAfterSelect: true,
					plugins: { remove_button: { title: "Remove this item" } },

					// On force le placeholder à partir de l'attribut du select
					placeholder: select.getAttribute("placeholder"),

					onChange: function (value) {
						// On déclenche l'événement resize nativement
						window.dispatchEvent(new Event("resize"));
					},

					render: {
						item: function (item, escape) {
							// SI LA VALEUR EST VIDE : On retourne le placeholder sans structure complexe
							if (item.value === "") {
								return `<div class="placeholder">${escape(select.getAttribute("placeholder"))}</div>`;
							}
							return CareSelector.renderLabel(item, escape);
						},
						option: function (item, escape) {
							// On ne veut pas afficher l'option vide dans la liste déroulante
							if (item.value === "") {
								return '<div style="display:none"></div>';
							}
							return CareSelector.renderLabel(item, escape);
						},
					},

					// Sécurité : au chargement, si la valeur est vide, on vide les items internes
					onInitialize: function () {
						if (this.getValue() === "") {
							this.clear(true); // true pour ne pas déclencher d'événement 'change'
						}
					},
				});
			});
		};

		if (typeof window.TomSelect === "function") {
			selector();
		} else {
			// TomSelect not yet loaded: listen for script load
			const interval = setInterval(() => {
				if (typeof window.TomSelect === "function") {
					clearInterval(interval);
					selector();
				}
			}, 100);

			// Optionally, clean up after 10s
			setTimeout(() => clearInterval(interval), 10000);
		}
	},

	renderLabel(item, escape) {
		const label = item.text || "";
		const isParent = item.$option?.getAttribute("data-parent") === "1" || item["data-parent"] === "1";

		return `<div>${isParent ? `<strong>${escape(label)}</strong>` : `<span>${escape(label)}</span>`}</div>`;
	},
};
